(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-audio-control"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const playPauseButtons = document.querySelectorAll('.play-pause');
  const volumeSliders = document.querySelectorAll('.volume');

  playPauseButtons.forEach(btn => {
    const video = document.getElementById(btn.dataset.videoId);
    btn.addEventListener('click', () => {
      if(video.paused) {
        video.play();
        btn.textContent = 'Pause';
      } else {
        video.pause();
        btn.textContent = 'Play';
      }
    });
  });

  volumeSliders.forEach(slider => {
    const video = document.getElementById(slider.dataset.videoId);
    slider.addEventListener('input', () => {
      video.volume = slider.value;
      video.muted = slider.value == 0;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
